import { Geometry, Vector3, Line, LineBasicMaterial } from 'three'

export default class Dimension {
    constructor(){
        this.setDimension();
    }

    setDimension(){
        var material = new LineBasicMaterial({
            color: 0x808080,
            depthTest: false
        });
        
        var geometry = new Geometry();
        geometry.vertices.push(
            new Vector3( 0, 0, 0 ),
            new Vector3( 1, 0, 0 )
        );
        
        var line = new Line( geometry, material );
        this.object3d = line;
    }

    getDimension(){
        return this.object3d;           
    }
}
